import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  AppBar,
  Toolbar
} from "@mui/material";
import { Close as CloseIcon, Print as PrintIcon } from "@mui/icons-material";

const ThermalReceipt = ({ open, onClose, receiptData }) => {

  const [company, setCompany] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("companyInfo");
    if (stored) setCompany(JSON.parse(stored));
  }, []);

  // =========================================
  // PRINT FUNCTION (THERMAL SAFE)
  // =========================================
  const handlePrint = () => {

    const content = document.getElementById("thermal-receipt").innerHTML;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Receipt</title>

          <style>
            *{
              box-sizing:border-box;
              font-family: monospace;
            }

            body{
              width:58mm;
              margin:0 !important;
              padding:2mm !important;
              font-size:11px;
              line-height:1.4;
              color:black;
            }

            .center{text-align:center;}
            .right{text-align:right;}
            .bold{font-weight:bold;}
            .line{
              margin:6px 0;
              text-align:center;
              letter-spacing:1px;
            }

            @page{
              size:58mm auto;
              margin:0 !important;
            }

            @media print{
              html,body{
                width:58mm !important;
                margin:0 !important;
                padding:2mm !important;
              }
            }

            /* SPACE FOR CUTTER */
            .cut-space{
              height:20px;
            }

          </style>
        </head>

        <body>
          ${content}
        </body>
      </html>
    `);

    doc.close();
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 800);
  };

  if (!receiptData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>

      <AppBar position="static" color="success">
        <Toolbar variant="dense">
          <Typography sx={{ flexGrow: 1 }}>
            Patient Receipt
          </Typography>
          <IconButton color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent>

        {/* ============================= */}
        {/* RECEIPT CONTENT */}
        {/* ============================= */}
        <Box id="thermal-receipt" sx={{ width: "58mm", mx: "auto" }}>

          {/* HEADER */}
          <div className="center">
            <div className="bold" style={{ fontSize: "13px" }}>
              {company?.name || "Hospital Name"}
            </div>
            <div>{company?.location}</div>
            <div>{company?.phone}</div>
          </div>

          <div className="line">--------------------------------</div>

          <div className="center bold">PATIENT BILL</div>

          <div className="line">--------------------------------</div>

          {/* INFO */}
          <div>
            Patient ID: <b>{receiptData.patientId}</b><br/>
            Name: {receiptData.patientName}<br/>
            Receipt No: {receiptData.receipt}<br/>
            Date: {new Date(receiptData.time).toLocaleString()}
          </div>

          <div className="line">--------------------------------</div>

          {/* TOTALS */}
          <div>
            Amount Paid: {Number(receiptData.paid || 0).toFixed(2)}<br/>
            Total Due: {Number(receiptData.total || 0).toFixed(2)}<br/>
            Balance: {Number(receiptData.balance || 0).toFixed(2)}<br/>
            Payment Mode: {receiptData.paymentMode || "Cash"}<br/>
            Cashier: {receiptData.user}
          </div>

          <div className="line">--------------------------------</div>

          {/* FOOTER */}
          <div className="center" style={{ marginTop: "6px" }}>
            <div style={{ fontStyle: "italic" }}>
              Thank you for visiting {company?.name || "Hospital"}
            </div>
            <div>Soluce-Tech (+233 55 226 0549)</div>
          </div>

          {/* CUT SPACE */}
          <div className="cut-space"></div>

        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined" startIcon={<CloseIcon />}>
          Close
        </Button>

        <Button
          onClick={handlePrint}
          variant="contained"
          color="success"
          startIcon={<PrintIcon />}
        >
          Print Receipt
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default ThermalReceipt;
